import { Box, Text } from "@chakra-ui/react";
import Chart from "react-apexcharts";
import { useState, useEffect } from "react";

const BarChart = ({ skillsCount }) => {
  console.log(skillsCount)
  const barChartData = {
    options: {
      dataLabels: {
        enabled: true,
      },
      legend: {
        show: true,
        position: "bottom",
      },
      xaxis: {
        categories: [],
      },
    },
    series: [
      {
        name: "Common Skill",
        data: [],
      },
    ],
  };

  const [state, setState] = useState(barChartData);

  useEffect(() => {
    if (Object.keys(skillsCount).length !== 0) parseData(skillsCount);
  }, []);

  const parseData = (skillsCount) => {
    let categories = [];
    let data = [];
    for (let key in skillsCount) {
      categories.push(key.substring(0, 15));
      data.push(Number(skillsCount[key]));
    }
    setState({
      series: [{ data: data }],
      options: { xaxis: { categories: categories } },
    });
  };

  return (
    <Box borderWidth="1px" borderRadius="lg" p="2">
      <Text textAlign="center">Most Common Skill in the Pool</Text>
      <Chart
        style={
          Object.keys(skillsCount).length === 0
            ? { display: "none" }
            : { display: "block" }
        }
        options={state.options}
        series={state.series}
        type="bar"
        width="330"
        height="330"
      />
    </Box>
  );
};

export default BarChart;
